 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AttendanceAppeal":"AttendanceAppeal","ChangeDefaultPassword":"ChangeDefaultPassword","EnterVerificationCode":"EnterVerificationCode","ForgotPassword":"ForgotPassword","OngoingLecture":"OngoingLecture","ResetPassword":"ResetPassword","all-lectures":"all-lectures","course-work-results-management~exam-results-management":"course-work-results-management~exam-results-management","course-work-results-management":"course-work-results-management","exam-results-management":"exam-results-management","course-work-sets":"course-work-sets","exam-course-work-prerequisites":"exam-course-work-prerequisites","examination-set-details":"examination-set-details","examination-sets":"examination-sets","examinations-taught-by-lecturer":"examinations-taught-by-lecturer","job-applications.vue":"job-applications.vue","lecture-attendance":"lecture-attendance","login":"login","my-calendar":"my-calendar","my-intakes":"my-intakes","resources":"resources","settings":"settings","tutorials":"tutorials"}[chunkId]||chunkId) + "." + {"AttendanceAppeal":"951b2beb","ChangeDefaultPassword":"d6d19e56","EnterVerificationCode":"98c71bab","ForgotPassword":"b760051d","OngoingLecture":"43bf1ff4","ResetPassword":"ce59e475","all-lectures":"3d50f7fa","course-work-results-management~exam-results-management":"072b7240","course-work-results-management":"4f9d3f81","exam-results-management":"8645c5b8","course-work-sets":"6839132e","exam-course-work-prerequisites":"aeebe5c7","examination-set-details":"a22b3acc","examination-sets":"a1fad337","examinations-taught-by-lecturer":"b398642d","job-applications.vue":"150449ec","lecture-attendance":"ba90d08a","login":"bbdc3c9b","my-calendar":"66f78cc2","my-intakes":"c15b0bd7","resources":"670f173c","settings":"96ad7ade","tutorials":"b41eed8a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AttendanceAppeal":1,"ChangeDefaultPassword":1,"EnterVerificationCode":1,"ForgotPassword":1,"OngoingLecture":1,"ResetPassword":1,"all-lectures":1,"course-work-results-management~exam-results-management":1,"course-work-results-management":1,"exam-results-management":1,"course-work-sets":1,"exam-course-work-prerequisites":1,"examination-set-details":1,"examination-sets":1,"examinations-taught-by-lecturer":1,"job-applications.vue":1,"lecture-attendance":1,"login":1,"my-calendar":1,"my-intakes":1,"resources":1,"settings":1,"tutorials":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AttendanceAppeal":"AttendanceAppeal","ChangeDefaultPassword":"ChangeDefaultPassword","EnterVerificationCode":"EnterVerificationCode","ForgotPassword":"ForgotPassword","OngoingLecture":"OngoingLecture","ResetPassword":"ResetPassword","all-lectures":"all-lectures","course-work-results-management~exam-results-management":"course-work-results-management~exam-results-management","course-work-results-management":"course-work-results-management","exam-results-management":"exam-results-management","course-work-sets":"course-work-sets","exam-course-work-prerequisites":"exam-course-work-prerequisites","examination-set-details":"examination-set-details","examination-sets":"examination-sets","examinations-taught-by-lecturer":"examinations-taught-by-lecturer","job-applications.vue":"job-applications.vue","lecture-attendance":"lecture-attendance","login":"login","my-calendar":"my-calendar","my-intakes":"my-intakes","resources":"resources","settings":"settings","tutorials":"tutorials"}[chunkId]||chunkId) + "." + {"AttendanceAppeal":"5c87ed34","ChangeDefaultPassword":"c55034d9","EnterVerificationCode":"93cd313d","ForgotPassword":"7d8f93fe","OngoingLecture":"3f785bd6","ResetPassword":"9c25e0cd","all-lectures":"7749894d","course-work-results-management~exam-results-management":"96168a7a","course-work-results-management":"78244219","exam-results-management":"d33de055","course-work-sets":"3e501025","exam-course-work-prerequisites":"e5ae2336","examination-set-details":"e816cf40","examination-sets":"a099ee1b","examinations-taught-by-lecturer":"668063e9","job-applications.vue":"4c046310","lecture-attendance":"7811049b","login":"2c49f3b3","my-calendar":"bf39615f","my-intakes":"fc2bbf22","resources":"58f4d8c8","settings":"762870f9","tutorials":"75e97863"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
